import { gsap } from "gsap";
import fragment from "./shader/fragment.glsl";
import vertex from "./shader/vertex.glsl";
import * as THREE from 'three';

export default class LoaderThree {
    constructor(container) {
        this.controls = null;
        this.camera = null;
        this.scene = null;
        this.renderer = null;
        this.aspect = window.innerWidth / window.innerHeight < 1 ? 'portrait' : 'landscape';
        this.container = container;

        this.mesh = null;
        this.bgMesh = null;
        this.isDone = false;
        this.material = null;

        this.init();
    }

    start() {
        gsap.to(this.material.uniforms.progress, {
            duration: 3,
            value: 0,
            ease: "power2.inOut",
            onComplete: () => {
                this.isDone = true;
                this.renderer.setAnimationLoop(null);

                gsap.to(this.renderer.domElement, {opacity: 0, duration: 0.2});
            }
        });
    }

    reverse(fallback) {
        gsap.to(this.renderer.domElement, {opacity: 1, duration: 0.2});
        this.isDone = false;
        this.renderer.setAnimationLoop(this.animate.bind(this));
        gsap.to(this.material.uniforms.progress, {
            duration: 2,
            value: 1,
            ease: "power2.inOut",
            onComplete: () => {
                this.isDone = true;
                this.renderer.setAnimationLoop(null);
                fallback();
            }
        });
    }

    init() {
        try {
            this.setupCamera();
            this.setupScene();
            this.setupItems();
            this.setupRenderer();
            window.addEventListener('resize', this.onWindowResize.bind(this));
        } catch (error) {
            console.error('Initialization failed:', error);
        }
    }

    setupItems() {

        this.image = document.querySelector('.loader-image');

        const aspect = {w:2, h:1};

        let geometry = new THREE.PlaneGeometry(aspect.w, aspect.h, 100, 100);
        this.material = new THREE.ShaderMaterial({
            extensions: {
                derivatives: "#extension GL_OES_standard_derivatives : enable"
            },
            side: THREE.DoubleSide,
            uniforms: {
                time: { type: "f", value: 0 },
                progress: { type: "f", value: 1 },
                angle: { type: "f", value: 0.1 },
                texture1: { type: "t", value: null },
                texture2: { type: "t", value: null },
                resolution: { type: "v4", value: new THREE.Vector4() },
                uvRate1: {
                    value: new THREE.Vector2(1, 1)
                }
            },
            transparent: true, // Ensure the material is transparent
            vertexShader: vertex,
            fragmentShader: fragment
        });

        const loader = new THREE.TextureLoader().load(
            this.image.src,
            //img,
            texture => {
                texture.needsUpdate = true;

                let imageWidth = texture.source.data.width;
                let imageHeight = texture.source.data.height;

                let a1 = (imageHeight / imageWidth) * aspect.w;
                let a2 = 1 * aspect.h;

                texture.minFilter = THREE.LinearFilter;
                this.material.uniforms.resolution.value.x = imageWidth;
                this.material.uniforms.resolution.value.y = imageHeight;
                this.material.uniforms.resolution.value.z = a1 *2;
                this.material.uniforms.resolution.value.w = a2 *2;

                this.material.uniforms.texture1.value = texture;
                this.material.uniforms.texture1.value.needsUpdate = true;

                this.material.uniforms.texture2.value = texture;

                const imageMesh = new THREE.Mesh(geometry, this.material);
                this.scene.add(imageMesh);

                this.mesh = imageMesh;
            }
        );
    }

    setupCamera() {
        this.camera = new THREE.PerspectiveCamera(20, window.innerWidth / window.innerHeight, 0.1, 1000);
        this.camera.position.z = 1.2;
    }

    setupScene() {
        this.scene = new THREE.Scene();
    }

    setupRenderer() {
        this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true }); // Set alpha to true for transparency
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.setAnimationLoop(this.animate.bind(this));
        document.querySelector(this.container).appendChild(this.renderer.domElement);
    }

    onWindowResize() {
        this.aspect = (window.innerWidth / window.innerHeight) < 1 ? 'portrait' : 'landscape';
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
    }

    applyInertia() {
        //console.log(this.dragVelocityY);
    }

    animate() {
        this.applyInertia();
        this.renderer.render(this.scene, this.camera);
    }
}